import React, { useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  brokerUsersMetaSelector,
  brokerUsersSelector,
  createCustomToken,
  getAdminBrokers,
  isLoadingBrokerUsersSelector,
} from 'src/store/admin';

import { Status } from '../Status/Status';
import { Button } from '@mui/material';

export const useTable = (props) => {
  const { isImpersonate = true } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminBrokers = useSelector(brokerUsersSelector);
  const adminBrokersMeta = useSelector(brokerUsersMetaSelector);
  const isLoadingBrokerUsers = useSelector(isLoadingBrokerUsersSelector);

  const [, setCookie] = useCookies(['is_impersonate']);

  const onClickImpersonate = useCallback(
    (user_id) => async () => {
      const payload = {
        user_id,
        navigate,
      };

      await dispatch(createCustomToken(payload));
      setCookie('is_impersonate', 'true', { path: '/' });
    },
    [dispatch, navigate, setCookie],
  );

  const build = {
    title: isImpersonate ? 'Broker Impersonate' : '',
    filters: [
      {
        id: 'q',
        label: 'Search',
        type: 'search-input',
      },
    ],
    columns: [
      {
        id: 'email',
        name: 'Broker Email',
        sortable: true,
      },
      {
        id: 'last_active',
        name: 'Last Active',
        sortable: true,
      },
      {
        id: 'display_name',
        name: 'Broker Name',
        sortable: true,
      },
      {
        id: 'status',
        name: 'Status',
        value: (item) => <Status status={item?.status} />,
        sortable: true,
      },
      {
        id: '1',
        name: '',
        value: (item) =>
          isImpersonate ? (
            <Button variant="contained" onClick={onClickImpersonate(item?.id)} size="small">
              Impersonate
            </Button>
          ) : null,
        sortable: false,
      },
    ],
    data: adminBrokers,
    meta: adminBrokersMeta,
    api: {
      get: getAdminBrokers,
    },
    is_loading: isLoadingBrokerUsers,
  };

  return { build };
};
